angular.module('um').controller('menu.controller',
    ['$rootScope', '$scope', 'endpoints', '$state',
    function($rootScope, $scope, endpoints, $state) {

        $scope.endpoint = $state.includes('main.profile') ? endpoints['ssoMenuMYP'] : endpoints['ssoMenu'];

        $scope.suiteMenuConfig = {
            setEndpointConfig: $scope.endpoint
        };

        $scope.topMenuNavCollapsed = false;

        $rootScope.$on('$stateChangeStart', function (event, route) {
            if (_.contains(route.name, 'profile')) {
                $scope.endpoint = endpoints['ssoMenuMYP'];
            } else {
                $scope.endpoint = endpoints['ssoMenu'];
            }
        });

        $scope.feedbackPopup = window.jiraFeedbackPopup;
    }
]);
